import { ColDef, RowNode } from "ag-grid-community";
import { ColumnTypes, getDateKey } from "../shipment-review-grid";
import { parseLineItemId } from "./buildDeliveryWindowColDef";

export const extractLineItemIdByRowNode = (colDef: ColDef, node: RowNode): string | undefined => {
    if (colDef.type !== ColumnTypes.DeliveryWindow) {
        return;
    }

    let childNode: RowNode;
    if (node.group) {
        // When rows are grouped, we need to find correct child by matching ship start and ship end
        childNode = node.allLeafChildren.find((leaf) => {
            if (!leaf.data) {
                return false;
            }
            return getDateKey(leaf.data.shipStart, leaf.data.shipEnd) === colDef.colId;
        });
    } else {
        childNode = node;
    }

    if (!childNode) {
        return;
    }

    if (!childNode.data?.item?.id) {
        return;
    }

    // First id before `_` is line item id. We know this for a fact.
    const lineItemId = parseLineItemId(childNode.data.item.id);
    if (!lineItemId) {
        return;
    }

    return lineItemId;
};
